import { AlertNotificationDescription, cn, Spinner } from '@kar-dmp/ignite';

export const LoadingContainer = ({ children, className, ...props }) => (
	<div {...props} className={cn('mb-4 flex items-center justify-center', className)}>
		{children}
	</div>
);

export const LoadingSpinner = (props) => (
	<Spinner {...props} className={cn('size-10 animate-spin text-primary', props.className)} />
);

export const BannerContainer = ({ children, className, ...props }) => (
	<div {...props} className={cn('mb-4 w-full p-4 md:w-[640px]! md:p-0!', className)}>
		{children}
	</div>
);

export const PartnerContent = ({ children, className, ...props }) => (
	<div {...props} className={cn('flex items-start gap-4', className)}>
		{children}
	</div>
);

export const AffiliatePartnerLogo = ({ className, ...props }) => (
	<img {...props} className={cn('size-12 shrink-0 rounded-full object-contain', className)} />
);

export const AffiliatePartnerDescription = ({ children, className, ...props }) => (
	<AlertNotificationDescription {...props} className={cn('flex flex-col gap-2', className)}>
		{children}
	</AlertNotificationDescription>
);
